<template> 
   
    <div v-show="reloadQrCodeScan" style="height: 70px; width: 100%;">
        <loader-gif v-if="isRequestPresence" /> 
        <qrcode-stream :constraints="{ facingMode: 'environment' }" @detect="onDetect" @error="onError"
            :formats="barcodeFormats" />
    </div>

</template>

<script lang="ts">
import { ref } from 'vue';
 
import i18n from "@/i18n/index"
/*plugins*/
import { useVuelidate } from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";

/*composables & states */

import { usePresence } from "@/composables/presence/usePresence";
import { PresenceRequest } from "@/interfaces/presence";

import { QrcodeStream } from 'vue-qrcode-reader'
import { reloadQrCodeScan } from '@/shared/state';

export default {
    components: {
        QrcodeStream, 
    },
    setup() {

        const { addPresence, isRequestPresence } = usePresence();

        const requestPresence = ref<PresenceRequest>({
            id: null,
            date: '',
            checkIn: '',
            checkOut: '',
            memberUUID: ''
        });

        // Validation
        const rules = {
            memberUUID: {
                required: helpers.withMessage(i18n.t("validator.required"), required), String
            }
        };
        const v$ = useVuelidate(rules, requestPresence, { $scope: 'presence' });


        const submitForm = async () => {

            v$.value.$touch();
            if (!v$.value.$invalid) {
                await addPresence(requestPresence.value)
                requestPresence.value.memberUUID = ''

            }
        }
 
        const onDetect = (detectedCodes) => {
            console.log(detectedCodes)
            console.log(detectedCodes?.[0]?.rawValue)
            if (detectedCodes?.[0]?.rawValue) {
                requestPresence.value.memberUUID = detectedCodes?.[0]?.rawValue
                submitForm()
            }

        }
        const onError = (error) => {
            console.log(error)
            if (error.name === 'NotAllowedError') {
                // user denied camera access permission
            } else if (error.name === 'NotFoundError') {
                // no suitable camera device installed
            } else if (error.name === 'NotSupportedError') {
                // page is not served over HTTPS (or localhost)
            } else if (error.name === 'NotReadableError') {
                // maybe camera is already in use
            } else if (error.name === 'OverconstrainedError') {
                // did you request the front camera although there is none?
            } else if (error.name === 'StreamApiNotSupportedError') {
                // browser seems to be lacking features
            }
        }
        const barcodeFormats = ref(['qr_code'])
      
        return {
            reloadQrCodeScan,
            barcodeFormats,
            onError,
            onDetect,
            isRequestPresence,

        };
    },
};
</script>